var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-dialog',_vm._g(_vm._b({ref:"dialog",staticClass:"opc-dialog",class:{
    'opc-modal-dialog': _vm.isModal,
    'opc-modal-dialog__without-title': (_vm.isModal && _vm.notHasTitle)
  },attrs:{"show-close":!_vm.isModal},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slotName){return {key:slotName,fn:function(slotProps){return [_vm._t(slotName,null,null,slotProps)]}}})],null,true)},'zm-dialog',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }